import { FC } from 'react';

const SpinnerCenterIcon: FC<{
  borderColor: string;
  bgColor: string;
  iconColor: string;
}> = ({ borderColor, bgColor, iconColor }) => (
  <svg
    className="spinner-center-icon"
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25.9136"
      cy="25.3212"
      r="24"
      fill={bgColor}
      stroke={borderColor}
      strokeWidth="2"
    />
    <path
      d="M39.3084 14.1421H11.47C10.9596 14.1421 10.5911 14.5355 10.5911 15.0484V15.0832C10.5762 15.4716 10.6285 15.9198 10.743 16.4576C11.8584 23.5261 17.9883 28.929 25.3855 28.929C32.7826 28.929 38.788 23.6332 39.9906 16.6742C40.1449 16.0219 40.2072 15.499 40.1897 15.0509C40.1897 14.538 39.8213 14.1421 39.3109 14.1421H39.3084Z"
      fill={iconColor}
    />
    <path
      d="M32.6531 37.9844C32.0954 34.4513 29.0304 31.7474 25.3331 31.7474C21.6358 31.7474 18.6331 34.3941 18.0305 37.8748C17.9534 38.2035 17.921 38.4649 17.931 38.6865C17.931 38.9429 18.1152 39.1421 18.3716 39.1421H32.2921C32.546 39.1421 32.7303 38.9429 32.7327 38.689V38.674C32.7402 38.4798 32.7153 38.2582 32.6581 37.9869L32.6531 37.9844Z"
      fill={iconColor}
    />
  </svg>
);

export default SpinnerCenterIcon;
